export default {
      id: "planner-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#planner",
      toString: function () {
        return this.url;
      }
    }